<div class="container fw-b wrapper-content">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>
  <div class="container mb-4 wrapper-content">
    <div class="wallet-box">
      <div class="wallet-money">
        <div class="cardWallet walletBlock bg-blue wallet-new">
          <p class="text-white amt">
            {{
              (wallet?.walletAmount &&
                getPrice(wallet?.walletAmount | currency : "ZAR" : "R")) ||
                "R 0.00"
            }}
          </p>
          <button class="btn btn-theme mt-2" (click)="openModal()">
            Add Money to Wallet
          </button>
        </div>
        <div>
          <p class="text-theme">Wallet Balance</p>
        </div>
      </div>
      <!-- Commented-out sections remain unchanged -->
      <!-- <div class="col-3 text-center ml-1">
                <div class="cardWallet walletBlock bg-red">
                    <p class="text-white amt">{{ wallet?.totalWalletAmount && getPrice(wallet?.totalWalletAmount | currency:'ZAR':'R') || 'R 0.00'}}</p>
                </div>
                <div>
                    <p class="text-theme">Total Earning</p>
                </div>
            </div>
            <div class="col-3 text-center ml-1">
                <div class="cardWallet walletBlock bg-theme">
                    <p class="text-white amt">{{ wallet?.totalCommissionPaid && getPrice(wallet?.totalCommissionPaid | currency:'ZAR':'R') || 'R 0.00'}}</p>
                </div>
                <div>
                    <p class="text-theme">Total Commission Paid</p>
                </div>
            </div> -->
    </div>

    <div class="row mt-3">
      <div class="col-12 table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Serial No.</th>
              <th scope="col">From Wallet</th>
              <th scope="col">To Wallet</th>
              <th scope="col">Amount in R</th>
              <th scope="col">Transaction ID</th>
              <th scope="col">Status</th>
              <th scope="col">Transaction Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of orderList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
              <th>{{ 10 * (currentPage - 1) + i + 1 }}</th>
              <th scope="row">
                <ng-container *ngIf="item?.fromWalletType == 'OZW'">
                  OZOW Payment ({{ item?.fromWalletType }})
                </ng-container>
                <ng-container *ngIf="item?.fromWalletType == 'PAYGATE'">
                  PAYGATE Payment ({{ item?.fromWalletType }})
                </ng-container>
                <ng-container *ngIf="item?.fromWalletType == 'YOCO'">
                  YOCO Payment ({{ item?.fromWalletType }})
                </ng-container>
                <ng-container
                  *ngIf="
                    item?.fromWalletType != 'OZW' &&
                    item?.fromWalletType != 'PAYGATE' &&
                    item?.fromWalletType != 'YOCO'
                  "
                >
                  {{ item?.fromUser?.firstName }}
                  {{ item?.fromUser?.lastName }} ({{ item?.fromWalletType }})
                </ng-container>
              </th>
              <th scope="row">
                <ng-container *ngIf="item?.toWalletType == 'OZW'">
                  OZOW Payment ({{ item?.toWalletType }})
                </ng-container>
                <ng-container *ngIf="item?.toWalletType == 'PAYGATE'">
                  PAYGATE Payment ({{ item?.toWalletType }})
                </ng-container>
                <ng-container *ngIf="item?.toWalletType == 'YOCO'">
                  YOCO Payment ({{ item?.toWalletType }})
                </ng-container>
                <ng-container
                  *ngIf="
                    item?.toWalletType != 'OZW' &&
                    item?.toWalletType != 'PAYGATE' &&
                    item?.toWalletType != 'YOCO'
                  "
                >
                  {{ item?.toUser?.firstName || "--" }}
                  {{ item?.toUser?.lastName }} ({{ item?.toWalletType }})
                </ng-container>
              </th>
              <td
                [ngClass]="
                  item?.toUser?._id == myId ? 'text-success' : 'text-theme'
                "
              >
                {{ item?.toUser?._id == myId ? "+" : "-" }}
                {{
                  (item?.transactionAmount &&
                    getPrice(
                      item?.transactionAmount | currency : "ZAR" : "R"
                    )) ||
                    "--"
                }}
              </td>
              <td>{{ item?._id }}</td>
              <td>{{ item?.transactionStatus }}</td>
              <td>{{ item?.createdAt | date : "medium" || "--" }}</td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="orderList?.length === 0 && !isLoading"
          class="text-center py-5"
        >
          <p class="text-muted mb-3">
            No wallet transactions yet. Once you add money or make a purchase,
            your transaction history will appear here.
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="bi bi-receipt"
            width="58"
            height="58"
            fill="lightgray"
            viewBox="0 0 16 16"
          >
            <path
              d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"
            />
            <path
              d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
            />
          </svg>
        </div>
        <app-table-loader
          *ngIf="isLoading"
          [isTable]="'TABLE'"
          [isLoading]="isLoading"
          [notFoundData]="notFoundData"
          [colspan]="10"
          [isWidth]="'55px'"
        >
        </app-table-loader>
        <pagination-controls
          *ngIf="count > 10"
          style="float: right; margin-top: 3%"
          (pageChange)="changePageNumber($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="addMoneyModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top: 230px">
      <div class="modal-header" style="height: 90px; background: #bf1e2e">
        <h5
          class="modal-title"
          id="exampleModalLabel"
          style="width: 135px; height: 60px"
        >
          <img
            style="height: 100%; width: 100%; object-fit: cover"
            src="assets/img/whiteLogo.png"
            alt=""
          />
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <!-- <span aria-hidden="true" style="color: white;">×</span> -->
        </button>
      </div>
      <div class="modal-body">
        <div class="row justify-content-center">
          <div class="col-12 mb-2">
            <!-- Label added above the input box -->
            <label for="amount" class="form-label">Amount (in R)</label>
            <input
              type="number"
              id="amount"
              placeholder="Enter amount to add"
              [(ngModel)]="amount"
              max="999999"
              class="form-control"
            />
            <div class="for-validation mb-4">
              <!-- Show error message for 'required' if the field is touched and not filled -->
              <div class="for-validation text-danger" *ngIf="amount > 999999">
                *Amount cannot be greater than 999999.
              </div>
              <div class="for-validation text-danger" *ngIf="amount <= 0">
                *Invalid Amount.
              </div>
            </div>
          </div>
          <b class="col-12 text-center">Select Payment Method</b>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              (change)="getPayamnetMethod('paygate')"
              id="credit-card"
              name="payment"
              value="paygate"
            />
            <label for="credit-card">PayGate</label>
          </div>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              id="paypal"
              (change)="getPayamnetMethod('ozow')"
              name="payment"
              value="ozow"
            />
            <label for="paypal">Ozow</label>
          </div>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              id="yoco"
              (change)="getPayamnetMethod('yoco')"
              name="payment"
              value="yoco"
            />
            <label for="yoco">Yoco</label>
          </div>
         <div class="col-12 text-center mt-3">
  <button
    class="btn btn-theme fw-bold px-4 py-2"
    style="background-color: #bf1e2e; color: #fff; border-radius: 6px;"
    *ngIf="!htmlData"
    [disabled]="!paymentMethod || amount > 999999 || amount <= 0"
    (click)="onProceed()"
  >
    <i class="fa fa-wallet me-2"></i> Proceed to Add Money
  </button>

  <div *ngIf="htmlData" [innerHTML]="htmlData"></div>
</div>

        </div>
      </div>
    </div>
  </div>
</div>
